import { useAuth } from '../pages/login/OAuth';

const useOfferService = () => {
    const { api } = useAuth();

    const getOffer = (id) =>
        api().get(`/offers/${id}`);

    const getOffers = (params) =>
        api().get('/offers/', { params });

    const createOffer = (data) =>
        api().post('/offers/', data);

    const updateOffer = (data) =>
        api().patch('/offers/', data);

    const disableOffer = (id) =>
        api().patch('/offers/disable', { offer_id: id });

    const addOfferItem = (data) =>
        api().post('/offers/add_item', data);

    const disableOfferItem = (id) =>
        api().patch('/offers/disable_item', { item_id: id });

    const createBuildingFromOffer = (offerId) =>
        api().post('/offers/create_building', { offer_id: offerId });

    const getOfferPdf = (id) =>
        api().get(`/offers/${id}/generate-pdf`, { responseType: 'blob' });

    return {
        getOffer,
        getOffers,
        createOffer,
        updateOffer,
        disableOffer,
        addOfferItem,
        disableOfferItem,
        createBuildingFromOffer,
        getOfferPdf,
    };
};

export default useOfferService;
